const cronPurchaseAlcada = [
  {
    group: 'Alcada',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: true
      },
      {
        name: 'Usuário (E-mail)',
        id: 'user-nome',
        show: true
      },
      {
        name: 'De (%)',
        id: 'user-de',
        show: true
      },
      {
        name: 'Até (%)',
        id: 'user-ate',
        show: true
      },
      {
        name: 'Itens sem recomendação',
        id: 'user-sem-recomendacao',
        show: true
      }
    ]
  }
]
export default cronPurchaseAlcada
